import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Radio,
  RadioGroup,
  Typography,
} from "@material-ui/core";
import React from "react";
import SelectErp from "../../basics/SelectErp";
import MaskService from "../../../utils/mask/maskService";

const DocumentGuideManagerFields = ({
  folderSystem,
  setFolderSystem,
  folderType,
  setFolderType,
  listCustomers,
  sendTo,
  setSendTo,
}) => {
  return (
    <>
      <div id="demo-simple-select-standard-label">
        Selecione para onde o documento deve ser enviado
      </div>
      <FormControl component="fieldset">
        <RadioGroup
          color="primary"
          value={folderType}
          name="radio-buttons-group"
          row
        >
          <FormControlLabel
            value="guide"
            control={<Radio color="primary" />}
            onClick={(e) => {
              setFolderType(e.target.value);
              setFolderSystem("fiscal");
            }}
            label="Guias"
          />
          <FormControlLabel
            value="report"
            control={<Radio color="primary" />}
            onClick={(e) => {
              setFolderType(e.target.value);
              setFolderSystem("contabil");
            }}
            label="Relatórios"
          />
          <FormControlLabel
            value="doc"
            control={<Radio color="primary" />}
            onClick={(e) => {
              setFolderType(e.target.value);
              setFolderSystem("contratoTrabalho");
            }}
            label="Documentos"
          />
        </RadioGroup>
      </FormControl>

      <div>
        Selecione a pasta para envio{" "}
        {localStorage.getItem("isAccountantPanel") === "true"
          ? "no Portal do Cliente"
          : ""}
      </div>
      <FormControl component="fieldset" row>
        <FormGroup row>
          {folderType !== "doc" && (
            <FormControlLabel
              label={<Typography variant="body2">Contábil</Typography>}
              control={
                <Checkbox
                  color="primary"
                  checked={folderSystem === "contabil"}
                  onChange={(ev) => {
                    if (ev.target.checked) {
                      setFolderSystem("contabil");
                    }
                  }}
                />
              }
            />
          )}
          {folderType !== "doc" && (
            <FormControlLabel
              label={<Typography variant="body2">Fiscal</Typography>}
              control={
                <Checkbox
                  color="primary"
                  checked={folderSystem === "fiscal"}
                  onChange={(ev) => {
                    if (ev.target.checked) {
                      setFolderSystem("fiscal");
                    }
                  }}
                />
              }
            />
          )}
          {folderType !== "doc" && (
            <FormControlLabel
              label={<Typography variant="body2">Folha</Typography>}
              control={
                <Checkbox
                  color="primary"
                  checked={folderSystem === "folha"}
                  onChange={(ev) => {
                    if (ev.target.checked) {
                      setFolderSystem("folha");
                    }
                  }}
                />
              }
            />
          )}

          {folderType === "doc" && (
            <FormControlLabel
              label={
                <Typography variant="body2">Contrato de Trabalho</Typography>
              }
              control={
                <Checkbox
                  color="primary"
                  checked={folderSystem === "contratoTrabalho"}
                  onChange={(ev) => {
                    if (ev.target.checked) {
                      setFolderSystem("contratoTrabalho");
                    }
                  }}
                />
              }
            />
          )}
          {folderType === "doc" && (
            <FormControlLabel
              label={<Typography variant="body2">Contrato Social</Typography>}
              control={
                <Checkbox
                  color="primary"
                  checked={folderSystem === "contratoSocial"}
                  onChange={(ev) => {
                    if (ev.target.checked) {
                      setFolderSystem("contratoSocial");
                    }
                  }}
                />
              }
            />
          )}
          {folderType && (
            <FormControlLabel
              label={<Typography variant="body2">Outros</Typography>}
              control={
                <Checkbox
                  color="primary"
                  checked={folderSystem === "outros"}
                  onChange={(ev) => {
                    if (ev.target.checked) {
                      setFolderSystem("outros");
                    }
                  }}
                />
              }
            />
          )}
        </FormGroup>
      </FormControl>

      <SelectErp
        variant="outlined"
        label="Enviar para"
        size="medium"
        value={sendTo}
        setValue={setSendTo}
        optionsList={listCustomers}
        descriptionField="company_name"
        getOptionLabel={(option) => {
          let maskedDocument = "";
          if (option.document.length === 14) {
            maskedDocument = MaskService.toMask("cnpj", option.document);
          } else {
            maskedDocument = MaskService.toMask("cpf", option.document);
          }

          return `${option.company_name} - ${maskedDocument}`;
        }}
        style={{ marginTop: "8px", width: "260px" }}
      />
    </>
  );
};

export default DocumentGuideManagerFields;
